/**
 * Formats a number as Indonesian Rupiah currency.
 * @param {number|string} value - The value to format
 * @param {object} options - Optional formatting options
 * @returns {string} Formatted currency string (e.g., 'Rp 1.500.000')
 */
export const formatCurrency = (value, options = {}) => {
    if (value === null || value === undefined || value === "") return "-";

    const numValue = typeof value === "string" ? parseFloat(value) : value;

    if (isNaN(numValue)) return "-";

    const defaultOptions = {
        style: "currency",
        currency: "IDR",
        maximumFractionDigits: 0,
    };

    return new Intl.NumberFormat("id-ID", {
        ...defaultOptions,
        ...options,
    }).format(numValue);
};

/**
 * Formats a number with Indonesian thousand separators.
 * @param {number|string} value - The value to format
 * @returns {string} Formatted number string (e.g., '1.500.000')
 */
export const formatThousands = (value) => {
    if (value === null || value === undefined || value === "") return "-";

    const numValue = typeof value === "string" ? parseFloat(value) : value;

    if (isNaN(numValue)) return "-";

    return new Intl.NumberFormat("id-ID").format(numValue);
};
